(function() {
	function time() {
		return Math.round((new Date()).getTime() / 1000);
	}
	var cookieBanner = {
		has: function(cookieName) {
			var cookieRegExp = new RegExp(cookieName + '=([^;]+)');
			return document.cookie.match(cookieRegExp);
		},
		get: function(cookieName) {
			var cookieRegExp = new RegExp(cookieName + '=([^;]+)');
			var match = document.cookie.match(cookieRegExp);
			if (match) return match[1];
		},
		set: function(cookieName, timestamp) {
			var expiryDate = new Date(timestamp);
			document.cookie = cookieName + '=' + time() + ';path=/; expires=' + expiryDate.toGMTString();
		}
	};

	window.notificationBanner = {
		init: function(opts) {
			if (!cookieBanner.has(opts.name) || cookieBanner.get(opts.name) === '') {

				var banner = document.getElementById('notfication-banner');
				var closeBtn = document.getElementById('close-notification');
				var body = document.body;

				body.classList.add('notification-banner');
				banner.classList.add('show');

				closeBtn.addEventListener("click", function( event ) {
					banner.classList.add('close');
					body.classList.remove('notification-banner');
					cookieBanner.set(opts.name, opts.expire)
				}, false);
			}
		}
	}
})();
